import React from "react";
import "./style.css";

const ResultadoInicial = () => {
  return (
    <div className="routes">
      <div className="cabecalho-pesquisa">
        <h2>Resultados da Busca</h2>
      </div>
      <div className="cabecalho-pesquisa">
        <p>Utilize o formulário ao lado para buscar um filme ou série.</p>
      </div>
    </div>
  );
};
export default ResultadoInicial;
